/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type GetParticipationSurveyJobCompanyJobsRequest = {
    /**
     * The survey job definition ID to map
     */
    surveyJobDefinitionId: string;
    /**
     * Plan ID (defaults to current plan)
     */
    planId?: number;
    /**
     * Filter by company job level IDs
     */
    jobLevel?: Array<number>;
    /**
     * Filter by company job family IDs
     */
    jobFamily?: Array<number>;
    /**
     * Filter by company job sub-family IDs
     */
    jobSubFamily?: Array<number>;
    /**
     * Search term for job title/code/description (uses OpenSearch for fuzzy matching)
     */
    search?: string;
    sort?: {
        jobTitle?: GetParticipationSurveyJobCompanyJobsRequest.jobTitle;
        jobFamily?: GetParticipationSurveyJobCompanyJobsRequest.jobFamily;
        jobSubFamily?: GetParticipationSurveyJobCompanyJobsRequest.jobSubFamily;
        levelCode?: GetParticipationSurveyJobCompanyJobsRequest.levelCode;
        levelTitle?: GetParticipationSurveyJobCompanyJobsRequest.levelTitle;
    };
    limit?: number;
    offset?: number;
};

export namespace GetParticipationSurveyJobCompanyJobsRequest {

    export enum jobTitle {
        ASC = 'ASC',
        DESC = 'DESC',
    }

    export enum jobFamily {
        ASC = 'ASC',
        DESC = 'DESC',
    }

    export enum jobSubFamily {
        ASC = 'ASC',
        DESC = 'DESC',
    }

    export enum levelCode {
        ASC = 'ASC',
        DESC = 'DESC',
    }

    export enum levelTitle {
        ASC = 'ASC',
        DESC = 'DESC',
    }


}

